<template>
    <!-- 发布新版本 -->
    <div class="">
      <v-dialog
        class="popbox add-new-version"
        name="dialog2"
        v-model="isShow"
        :title="dialogTitle"
        close-on-click-modal
        :modal="true"
        :width="668"
        @open="open"
        @after-close="handleAfterClose"
        @confirm="handleConfirm"
        append-to-body
      >

        <v-form ref="form" :model="ruleForm" :rules="rules">
          <v-form-item label="父版本信息" prop="fatherVison" class="fatherInfo" v-if="fatherVison">
            <span class="fatherVsion fileUrl">
              {{fatherProduct}}_{{ fatherSoftware }}_{{ fatherVersion_type }}
            </span>
          </v-form-item>

          <v-form-item  prop="product_keys" >
            <template slot="label">
              <span class="required">*</span>
              <span>产品</span>
            </template>

            <v-select
              isMultiple
              multipleShowAll
              id="product_keys"
              :disabled="fatherVison != ''"
              insertContains="product_keys"
              name="product_keys"
              :placeholder="productKeyOptins.length > 0 ? '请选择' : '请先新建产品'"
              :value="ruleForm.product_keys"
              :options="productKeyOptins"
            />

          </v-form-item>
          <v-form-item  prop="software_version" :required="true">
            <template slot="label">
              <span class="required">*</span>
              <span>软件版本</span>
            </template>
            <v-input type="text" name="software_version" v-model="ruleForm.software_version"></v-input>
          </v-form-item>
          <v-form-item prop="version_type">
            <template slot="label">
              <span class="required">*</span>
              <span>版本类型</span>
            </template>
              <v-select id="list_version_type" insertContains="list_version_type" name="version_type" v-model="ruleForm.version_type" :options="versionTypeOptions"></v-select>
            </v-form-item>

            <v-form-item class="listfile" prop="listFile" :required="false">
              <template slot="label">
              <span class="required">*</span>
              <span>固件上传</span>
            </template>
                <v-upload
                action="/cgi-bin/upload"
                ref="upload"
                name="upload"
                accept=".trx,.bin"
                :WfileName="WfileName"
                show-file-list
                :on-change="hidemsg"
                @showtips="showfiletips"
                ></v-upload>
                <div class="filetip" ref="filetip">未选择文件</div>
              </v-form-item>

          <v-form-item  prop="hardware_version" >
            <template slot="label">
              <span class="required">*</span>
              <span>硬件版本</span>
            </template>
            <v-input type="text" name="hardware_version" v-model="ruleForm.hardware_version"></v-input>
          </v-form-item>
          <v-form-item  prop="version_secret" >
            <template slot="label">
              <span class="required">*</span>
              <span>版本密码</span>
            </template>
            <v-input type="text" name="version_secret" v-model="ruleForm.version_secret"></v-input>
          </v-form-item>
          <v-form-item  prop="enterprise_name" >
            <template slot="label">
              <span class="required">*</span>
              <span>企业名称</span>
            </template>
            <v-input type="text" name="enterprise_name" v-model="ruleForm.enterprise_name" ></v-input>
          </v-form-item>

          <v-form-item prop="disabled_cloud">
            <template slot="label">
              <span class="required">*</span>
              <span>是否禁用云服务</span>
            </template>
              <v-radio class="options" v-model="ruleForm.disabled_cloud" name="disabled_cloud" :options="disabledCloudOptions"></v-radio>
          </v-form-item>

          <v-form-item prop="recursion">
            <template slot="label">
              <span class="required">*</span>
              <span>是否跳过当前版本</span>
            </template>
              <v-radio class="options" v-model="ruleForm.recursion" name="recursion" :options="recursionList"></v-radio>
          </v-form-item>

          <v-form-item  prop="system" >
            <template slot="label">
              <span class="required">*</span>
              <span>系统</span>
            </template>
            <v-input type="text" name="system" v-model="ruleForm.system"></v-input>
          </v-form-item>

          <v-form-item prop="author_description">
            <template slot="label">
              <span class="required">*</span>
              <span>作者描述</span>
            </template>
            <v-input type="textarea" class="Description" name="author_description" :maxlength="200" show-word-limit v-model="ruleForm.author_description"></v-input>
          </v-form-item>

          <v-form-item prop="language">
            <template slot="label">
              <span class="required">*</span>
              <span>语言</span>
            </template>
            <v-checkbox-group v-model="languageDataArr" name="language" :options="languageOptions" @click="handleClick"></v-checkbox-group>
            <div><v-button type="primary" name="btn-s"  size="S" @click="showAddLag" >添加语言</v-button></div>
          </v-form-item>

          <v-form-item prop="descpSelect" v-for="(item,index) in languageDataArr" v-bind:key="index"  class="descp-language">
              <v-form-item  prop="change_log" >
                <template slot="label">
                  <span class="required"></span>
                  <span>更新日志({{item}})</span>
                </template>
                <v-input type="textarea" class="Description" name="change_log" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].change_log"></v-input>
              </v-form-item>

              <v-form-item  prop="new_func">
                <template slot="label">
                  <span class="required"></span>
                  <span>新功能({{item}})</span>
                </template>
                <v-input type="textarea" class="Description" name="new_func" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].new_func"></v-input>
              </v-form-item>

              <v-form-item  prop="optimization">
                <template slot="label">
                  <span class="required"></span>
                  <span>优化内容({{item}})</span>
                </template>
                <v-input type="textarea" class="Description" name="optimization" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].optimization"></v-input>
              </v-form-item>

              <v-form-item  prop="memo">
                <template slot="label">
                  <span class="required"></span>
                  <span>备注({{item}})</span>
                </template>
                <v-input type="textarea" class="Description" name="memo" :maxlength="200" show-word-limit v-model="ruleForm.descp_lang[index].memo"></v-input>
              </v-form-item>
          </v-form-item>

        </v-form>
        <v-loading class="loading-box"  :visible="!upTips" name="loading4"></v-loading>

      </v-dialog>
      <addLag :showAddDialog.sync="AddLoading"  ref="add"  @change="showAddLag()" @addNewLag = "addNewLag"></addLag>

    </div>

</template>

  <script>
import { copy } from '@/common/libs/utils';
import OSS from 'ali-oss'
import addLag from './add-lag.vue'
import SparkMD5 from 'spark-md5'

  export default {
    components: {addLag},
    props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    fatherVison:{},
    fatherProduct:{},
    fatherSoftware:{},
    fatherVersion_type:{},
  },
    data() {
      return {
        rules: {
          software_version: copy([{
            type: "len",
            args: [1,128]
          }]),
          hardware_version: copy([{
            type: "ascii",
            args: [1,30]
          }]),
          version_secret: copy([{
            type: "ascii",
            args: [1,30]
          }]),
          enterprise_name: copy([{
            type: "len",
            args: [1,128]
          }]),
          system: copy([{
            type: "ascii",
            args: [1,30]
          }]),

      },
        ruleForm:{
          product_keys: [],     // 产品
          version_type: "", //版本类型
          software_version: "",    //软件版本
          hardware_version: "",               //硬件版本
          version_secret: "",                              //版本密码
          enterprise_name: "Tenda",               //公司
          language: [],
          author_description:'',
          disabled_cloud: 1,            //禁用云服务
          system: "",                   //系统
          descp_lang:[],
          file_url: "",               //固件地址
          file_hash: "",                  //hash
          image_size: 0,
          previous_ver_id: '',
          recursion: 1,
          next_ver_id: 0,
          app_id: sessionStorage.getItem("appid") || "",
        },
        recursionList:[
          {
            label:'是',
            value: 1
          },
          {
            label:'否',
            value: 0
          }
        ],
        dialogTitle: "发布新版本",
        versionTypeOptions:[
            {
              label: "正式版",
              value: "release"
            },
            {
              label: "测试版",
              value: "beta"
            }
        ],
        disabledCloudOptions:[
          {
            label: "禁用",
            value: 0
          },
          {
            label: "不禁用",
            value: 1
          }
        ],
        languageOptions:[
          {
            label:'中文简体',
            value:'zh-Hans'
          },{
            label:'中文繁体',
            value:'zh-Hant'
          },{
            label:'英文',
            value:'en'
          },{
            label:'乌克兰语',
            value:'uk'
          },{
            label:'俄罗斯语',
            value:'ru'
          },{
            label:'德语',
            value:'de'
          },
        ],
        productKeyOptins: [],
        languageDataArr: [],

        isShow:false,
        enable:'on',
        AddLoading:false,
        upTips:true,
        WfileName:'',
      };
    },
    created() {
    },
    watch:{
      showInputDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {

      showAddLag(){
        this.AddLoading = !this.AddLoading
      },
      addNewLag(data){
        if(!this.languageOptions.includes(data)){
          this.languageOptions.push(data)
        }else{
          this.$message.error('已经存在该语言');
        }
      },
      open(){
        this.getData()
        this.getProductList()
        this.ruleForm.previous_ver_id = Number(this.fatherVison)
      },
      getProductList(){
        const submitData = {
          app_id: sessionStorage.getItem("appid") || "",
        }
        this.$post("/td/td-iot-api/iot/common/product/list/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.productKeyOptins = res.data.map((item) =>{
              return {
                label: item.product_name,
                value: item.product_key
              }
            })
            this.productKeyOptins.map((item)=>{
              if(item.label == this.fatherProduct){
                this.ruleForm.product_keys.push(item.value)
              }
            })
          }else {
            this.$message.error(res.msg);
          }
        });

      },
      showfiletips(){
        this.$refs.filetip.style.display = "block";
      },
      hidemsg(e,file){
        this.$message.warn("文件上传中,请等待...")
        this.upTips = false
        let _this = this
        this.$refs.filetip.style.display = "none";
        if (window.FileReader) {
        var fi = e.target.files[0];
        //计算文件大小，赋值等待提交
        this.ruleForm.image_size = fi.size
        const fileReader = new FileReader()
        fileReader.readAsBinaryString(fi);
        fileReader.onload = e => {
          //将文件内容读取，进行MD5加密生成hash值上传
          const md5 = SparkMD5.hashBinary(e.target.result);
          _this.ruleForm.file_hash = md5.toUpperCase()
        }
       }
        //匹配上传地址文件夹
        this.address = this.ruleForm.version_type == 'release' ? `/${sessionStorage.getItem('appid') || ''}/firmware/release/` : `/${sessionStorage.getItem("appid") || ""}/firmware/beta/`
        //文件上传至OSS服务器，返回储存地址
        this.client.put(`${this.address}` + file, e.target.files[0]).then((result) => {
          if(result.res.statusCode == 200){
            this.WfileName = file
            this.$message.success("文件上传成功")
            this.upTips = true
            this.ruleForm.file_url = result.url
          }else{
            this.$message.error("文件上传失败")
            this.upTips = true
          }
        })
      },
      async getData(){
        const res = await this.$getData(
          "/td/td-iot-api/iot/oss-bridge/sts-token/v1",
        );
        this.client = new OSS({
          region: 'oss-cn-shenzhen',
          secure:true,
          accessKeyId: res.data.access_key_id,
          accessKeySecret: res.data.access_key_secret,
          bucket: 'tenda-iot' ,
          stsToken:res.data.security_token
        });
      },
      handleConfirm() {
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }
        if(this.ruleForm.file_url == ''){
          this.$refs.filetip.style.display = "block";
          this.$message.error("请检查错误信息")
          return
        }
        this.ruleForm.language = this.languageDataArr.toString()
        let submitData = { ...this.ruleForm };
        this.$post("/td/td-iot-api/iot/firmware/v1", submitData, false).then((res) => {
          let code = +res.code;
          if (code === 0) {
            this.$emit('getData')
            this.$message.success(res.msg);
          }
          else {
            this.$message.error(res.msg);
          }
        });
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleAfterClose() {
        this.$emit('getData')
        this.$emit('update:showInputDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
      handleClick(data) {
        const isNew = this.languageDataArr.indexOf(data) === -1
        const index = this.languageDataArr.indexOf(data)
        // this.ruleForm.language.indexOf(data) 值为-1时为新增，否则为删除，值为索引值
        if(isNew){
          this.ruleForm.descp_lang.push({
              language: data,
              change_log:'',
              new_func:'',
              optimization:'',
              memo:'',
        })
        }else{
          this.ruleForm.descp_lang.splice(index,1)
        }
      }
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
  .fatherInfo{
    color: #ff801f;
    font-weight: 550;
  }
  .add-new-version {
    .v-select--medium .input-text {
      min-height: 32px;
    }
  }
  </style>
